// @flow strict

import type {SchedulerEvent} from 'src/types/scheduler';

// $FlowFixMe[nonstrict-import]
import {type ResourceState} from 'src/hooks/useResource';
import useNoStoreApi from 'src/hooks/useNoStoreApi';


export default function useSchedulerEvent(
  eventId: string,
): ResourceState<SchedulerEvent> {
  return useNoStoreApi<SchedulerEvent>(`scheduler/event/${eventId}`);
}
